import { cn } from 'lib/utils';

export const IndicatorRoot = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div {...props} className={'rounded-lg border bg-card text-card-foreground shadow-sm p-6 flex-1'} />
  );
};

export const IndicatorHeader = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  return <div {...props} className={cn('flex items-center', className)} />;
};

export const IndicatorTitle = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div {...props} className={cn('font-GilroySemibold text-gray-600 text-sm', className)} />
  );
};

export const IndicatorBody = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  return <div {...props} className={cn('py-2', className)} />;
};

export const IndicatorHighlight = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div {...props}
      className={cn('font-GilroyBold text-orange-500 text-lg', className)} />
  );
};

export const IndicatorFooter = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  return <div {...props} className={cn('flex items-center', className)} />;
};

export const IndicatorBadge = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div {...props}
      className={cn('font-GilroySemibold text-gray-500 bg-gray-200',
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs',
        className,
      )} />
  );
};